import React from 'react';
import { CarouselProvider } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import OverlayCarousel from './overlay-carousel';
var OverlayModal = function (_a) {
    var images = _a.images, isOverlayOpen = _a.isOverlayOpen, setOverlay = _a.setOverlay, initialSlide = _a.initialSlide, setSelectedImage = _a.setSelectedImage;
    return (React.createElement(CarouselProvider, { naturalSlideWidth: 1, naturalSlideHeight: 1, totalSlides: images.length, dragEnabled: true, touchEnabled: true, orientation: "horizontal", isPlaying: false, dragStep: 1, currentSlide: initialSlide },
        React.createElement(OverlayCarousel, { isOverlayOpen: isOverlayOpen, setOverlay: setOverlay, images: images, setSelectedImage: setSelectedImage })));
};
export default OverlayModal;
